import { render } from "./Gatilhos.vue?vue&type=template&id=a44b379a&scoped=true"
import script from "./Gatilhos.vue?vue&type=script&lang=js"
export * from "./Gatilhos.vue?vue&type=script&lang=js"

import "./Gatilhos.vue?vue&type=style&index=0&id=a44b379a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44b379a"]])

export default __exports__